import * as t from 'io-ts';
import { createObject, deleteObject, updateObject } from './generics';
export const GuideV = t.intersection([
    t.type({
        id: t.number,
        organization: t.string,
        event: t.string,
        nudge: t.string,
        guidance: t.string,
    }),
    t.partial({}),
], 'Command');
export class Guide {
}
Guide.create = createObject(GuideV, GuideV, 'guides');
Guide.update = updateObject(GuideV, GuideV, 'guides');
Guide.delete = deleteObject(GuideV, 'guides');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3VpZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWlkZGxld2FyZS9ndWlkZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLENBQUMsTUFBTSxPQUFPLENBQUM7QUFFM0IsT0FBTyxFQUFFLFlBQVksRUFBRSxZQUFZLEVBQUUsWUFBWSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBRXRFLE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRyxDQUFDLENBQUMsWUFBWSxDQUNsQztJQUNFLENBQUMsQ0FBQyxJQUFJLENBQUM7UUFDTCxFQUFFLEVBQUUsQ0FBQyxDQUFDLE1BQU07UUFDWixZQUFZLEVBQUUsQ0FBQyxDQUFDLE1BQU07UUFDdEIsS0FBSyxFQUFFLENBQUMsQ0FBQyxNQUFNO1FBQ2YsS0FBSyxFQUFFLENBQUMsQ0FBQyxNQUFNO1FBQ2YsUUFBUSxFQUFFLENBQUMsQ0FBQyxNQUFNO0tBQ25CLENBQUM7SUFDRixDQUFDLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztDQUNkLEVBQ0QsU0FBUyxDQUNWLENBQUM7QUFFRixNQUFNLE9BQU8sS0FBSzs7QUFDRixZQUFNLEdBQUcsWUFBWSxDQUFDLE1BQU0sRUFBRSxNQUFNLEVBQUUsUUFBUSxDQUFDLENBQUM7QUFDaEQsWUFBTSxHQUFHLFlBQVksQ0FBQyxNQUFNLEVBQUUsTUFBTSxFQUFFLFFBQVEsQ0FBQyxDQUFDO0FBQ2hELFlBQU0sR0FBRyxZQUFZLENBQUMsTUFBTSxFQUFFLFFBQVEsQ0FBQyxDQUFDIn0=